import { createApp } from 'vue';
import Axios from '@/Plugins/Axios';
import components from '@/components';

require('instant.page');
require('@/csrf');

/**
 * Create a fresh Vue application instance and attach it to the page
 */
createApp({
    components: {
        ...components,
    },
}).use(Axios)
    .mount('#app');
